export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  cover: string;
  publishDate: string;
  tags: string[];
  content: string[];
}

export const newsList: NewsItem[] = [
  {
    id: "n1",
    title: "《星际远征》口碑出炉：科幻类型再迎现象级作品",
    summary: "上映首周便登顶票房榜，《星际远征》凭借扎实的世界观与震撼的视听，被不少观众称为“近年最值得进影院的一部科幻片”。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20premiere%20event%20with%20a%20large%20glowing%20screen%20and%20audience%20silhouettes%2C%20deep%20blue%20lighting%20with%20warm%20orange%20stage%20glow%2C%20editorial%20news%20style%2C%20no%20text&width=800&height=500&seq=mp-news-n1&orientation=landscape",
    publishDate: "2025-10-08",
    tags: ["票房", "科幻"],
    content: [
      "由艾伦·沃克执导的科幻片《星际远征》上映首周便强势登顶票房榜，成为近期讨论度最高的院线作品之一。",
      "影片讲述了一支远征队穿越深空、追寻神秘信号的故事。导演在采访中表示，团队花了三年时间打磨世界观与视觉概念，希望让观众真正“相信”那个未来世界。",
      "从观众反馈来看，影片的特效场面与情感内核收获了大量好评。也有评论认为，影片在宏大叙事之外，对“人类为何要去更远的地方”这一命题做了温和的回应。",
      "目前影片仍在热映中，后续口碑走向值得持续关注。",
    ],
  },
  {
    id: "n2",
    title: "都市悬疑题材持续升温，多部新片宣布定档",
    summary: "随着观众对强情节内容的偏爱，都市悬疑正成为近期热门赛道，多部新作先后公布上映日期。",
    cover: "https://readdy.ai/api/search-image?query=Moody%20night%20city%20scene%20with%20rain%20and%20reflective%20wet%20streets%2C%20deep%20blue%20tone%20with%20orange%20streetlights%2C%20cinematic%20editorial%20style%2C%20no%20text&width=800&height=500&seq=mp-news-n2&orientation=landscape",
    publishDate: "2025-10-05",
    tags: ["悬疑", "定档"],
    content: [
      "近期，都市悬疑题材迎来一波集中定档，多部聚焦罪案侦破与人性抉择的作品陆续公布上映计划。",
      "业内人士认为，这类作品往往以紧凑的节奏和反转结构吸引观众，同时也能承载对现实议题的思考，因此具备了较好的市场基础。",
      "从已曝光的预告来看，新片在影像风格上更强调氛围营造，冷色调与光影对比成为共同的视觉语言。",
      "是否能在类型框架内讲出新鲜感，将是这一轮作品能否突围的关键。",
    ],
  },
  {
    id: "n3",
    title: "动画电影市场回暖，原创国漫成新亮点",
    summary: "多部原创动画作品接连取得不错成绩，观众对国产动画的期待正从“技术”转向“故事”。",
    cover: "https://readdy.ai/api/search-image?query=Colorful%20animated%20film%20artwork%20scene%20of%20floating%20islands%20and%20clouds%20at%20sunset%2C%20warm%20orange%20and%20soft%20blue%20palette%2C%20dreamy%20illustration%20style%2C%20no%20text&width=800&height=500&seq=mp-news-n3&orientation=landscape",
    publishDate: "2025-09-29",
    tags: ["动画", "国漫"],
    content: [
      "今年以来，多部原创动画电影在市场端表现亮眼，带动了观众对国产动画的持续关注。",
      "与过去强调技术突破不同，近期的讨论更多集中在剧本与人物塑造上。观众希望看到真正能打动人心的故事，而不仅是堆砌视觉奇观。",
      "多位从业者在访谈中提到，原创IP的培育需要更长周期，但一旦形成口碑，其生命力也更为持久。",
      "动画赛道的回暖，或许正是一个良好的开始。",
    ],
  },
  {
    id: "n4",
    title: "文艺片小众突围：口碑传播如何改变排片命运",
    summary: "一部起初排片有限的文艺片，凭借观众自发推荐实现票房逆袭，引发业内对“口碑长线”的讨论。",
    cover: "https://readdy.ai/api/search-image?query=Quiet%20art%20house%20cinema%20interior%20with%20warm%20orange%20lamps%20and%20deep%20blue%20shadows%2C%20intimate%20moody%20editorial%20photo%2C%20no%20text&width=800&height=500&seq=mp-news-n4&orientation=landscape",
    publishDate: "2025-09-22",
    tags: ["文艺", "口碑"],
    content: [
      "一部原本排片有限的文艺片，在上映后依靠观众的口口相传，逐步实现了排片与票房的双增长。",
      "这一现象再次说明，在信息高度透明的当下，真实口碑对长线放映的影响力正在上升。",
      "有影院经理表示，观众的推荐会直接影响他们的排片决策，优质内容依然有被看见的机会。",
      "对于创作者而言，这或许是一种鼓励：耐心打磨的作品，终会等到它的观众。",
    ],
  },
  {
    id: "n5",
    title: "经典修复重映成潮流，老片为何能重回大银幕",
    summary: "越来越多经典影片以修复版形式重回影院，怀旧情绪与观影仪式感成为主要驱动力。",
    cover: "https://readdy.ai/api/search-image?query=Vintage%20film%20reel%20and%20old%20projector%20with%20warm%20orange%20light%20beams%20in%20a%20dark%20blue%20room%2C%20nostalgic%20cinematic%20still%20life%2C%20no%20text&width=800&height=500&seq=mp-news-n5&orientation=landscape",
    publishDate: "2025-09-15",
    tags: ["重映", "经典"],
    content: [
      "近年来，经典影片的修复重映逐渐成为一种稳定的市场现象，不少老片重新回到大银幕。",
      "对许多观众来说，走进影院观看一部熟悉的旧作，是一次带有仪式感的集体记忆重温。",
      "修复技术也让老片焕发新生，更清晰的画质与声音，让新一代观众有机会重新认识这些作品。",
      "老片重映，既是情怀，也是电影文化传承的一种方式。",
    ],
  },
  {
    id: "n6",
    title: "暑期档复盘：类型多元成为最大关键词",
    summary: "从动作到动画，从悬疑到历史，暑期档的类型分布更加均衡，观众选择也更为多样。",
    cover: "https://readdy.ai/api/search-image?query=Summer%20cinema%20marquee%20lights%20at%20dusk%2C%20warm%20orange%20bulbs%20against%20deep%20blue%20evening%20sky%2C%20nostalgic%20cinematic%20editorial%20style%2C%20no%20text&width=800&height=500&seq=mp-news-n6&orientation=landscape",
    publishDate: "2025-09-08",
    tags: ["暑期档", "市场"],
    content: [
      "随着暑期档落下帷幕，业内开始对本季市场表现进行复盘。“类型多元”成为出现频率最高的关键词之一。",
      "与以往单一类型扎堆不同，本季各类题材都有代表作品，观众的选择空间明显扩大。",
      "分析认为，内容的丰富度有助于降低市场对个别爆款的依赖，让整体生态更加健康。",
      "下一个档期能否延续这种多元趋势，值得期待。",
    ],
  },
  {
    id: "n7",
    title: "电影音乐专题：那些被记住的旋律如何诞生",
    summary: "配乐往往是电影情绪的隐形推手，本期我们聊聊电影音乐背后的创作故事。",
    cover: "https://readdy.ai/api/search-image?query=Orchestra%20recording%20session%20in%20a%20dark%20studio%20with%20warm%20orange%20spotlights%20and%20deep%20blue%20background%2C%20cinematic%20editorial%20style%2C%20no%20text&width=800&height=500&seq=mp-news-n7&orientation=landscape",
    publishDate: "2025-08-30",
    tags: ["配乐", "专题"],
    content: [
      "有些电影情节会被淡忘，但它留下的旋律却能长久回响。配乐，是电影情绪最隐形的推手。",
      "本期专题，我们从创作流程谈起，试图理解一段旋律是如何与画面相互成就的。",
      "多位作曲者提到，好的配乐不是喧宾夺主，而是在观众最需要被触动的时刻，轻轻推上一把。",
      "当音乐与画面真正合二为一，电影才拥有了完整的呼吸。",
    ],
  },
  {
    id: "n8",
    title: "电影节观察：新人导演正在被更多看见",
    summary: "多场电影节将目光投向新锐创作者，新人导演的处女作获得了更多展映与讨论机会。",
    cover: "https://readdy.ai/api/search-image?query=Film%20festival%20red%20carpet%20at%20evening%20with%20warm%20orange%20lights%20and%20deep%20blue%20sky%2C%20elegant%20cinematic%20editorial%20style%2C%20no%20text&width=800&height=500&seq=mp-news-n8&orientation=landscape",
    publishDate: "2025-08-21",
    tags: ["电影节", "新人"],
    content: [
      "近期多场电影节不约而同地加大了对新人导演的扶持力度，让更多处女作有机会与观众见面。",
      "对年轻创作者而言，电影节不仅是展示窗口，也是与行业建立联系的重要机会。",
      "有策展人表示，影视行业需要持续注入新鲜视角，而新人正是其中最有活力的一部分。",
      "让新人被看见，也是在为行业储备明天。",
    ],
  },
  {
    id: "n9",
    title: "流媒体与院线：从竞争走向共生的新阶段",
    summary: "随着发行策略不断调整，流媒体与院线之间的关系，正在从对立走向更为务实的共存。",
    cover: "https://readdy.ai/api/search-image?query=Movie%20theater%20seats%20seen%20from%20behind%20facing%20a%20glowing%20screen%2C%20deep%20blue%20darkness%20with%20warm%20orange%20screen%20glow%2C%20cinematic%20editorial%20style%2C%20no%20text&width=800&height=500&seq=mp-news-n9&orientation=landscape",
    publishDate: "2025-08-12",
    tags: ["流媒体", "院线"],
    content: [
      "过去几年，流媒体与院线一度被视为彼此的竞争者。而如今，双方的发行策略正在变得更加务实。",
      "越来越多的作品尝试“院线优先、随后上线”的组合模式，在不同渠道之间寻找平衡。",
      "分析认为，观影场景的多样化并不必然意味着彼此取代，反而可能扩大整个市场的容量。",
      "从竞争到共生，或许才是这个行业更健康的走向。",
    ],
  },
  {
    id: "n10",
    title: "幕后揭秘：一部电影的特效镜头是怎样炼成的",
    summary: "从分镜到渲染，一个短短几秒的特效镜头，往往凝聚着团队数月的努力。本期带你走进幕后。",
    cover: "https://readdy.ai/api/search-image?query=VFX%20artist%20workstation%20with%20multiple%20monitors%20showing%20green%20screen%20footage%2C%20dark%20blue%20room%20with%20warm%20orange%20desk%20light%2C%20editorial%20style%2C%20no%20text&width=800&height=500&seq=mp-news-n10&orientation=landscape",
    publishDate: "2025-08-03",
    tags: ["特效", "幕后"],
    content: [
      "观众在银幕上看到的几秒钟特效镜头，背后往往是整个团队数月的反复打磨。",
      "本期我们梳理了特效制作的基本流程：从概念设计、分镜预演，到实拍、合成与最终渲染，每一步都环环相扣。",
      "多位从业者提到，特效的本质仍然是服务于故事，“看不见的特效”往往才是最好的特效。",
      "技术会不断更新，但讲好故事的初心不会改变。",
    ],
  },
];